import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/site";

/**
 * Handles the Emergent-managed Google sign-in return:
 * the provider lands us at <redirect>#session_id=... — exchange it once,
 * silently, then move on. Rendered synchronously from the router gate so it
 * runs before any auth checks.
 */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return; // StrictMode double-invoke guard
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      nav("/sign-in", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // discard the one-time session_id before any navigation
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.role === "admin" ? "/admin" : "/account", { replace: true, state: { user: data } });
      } catch {
        toast.error("Sign-in failed", { description: "Please try again." });
        nav("/sign-in", { replace: true });
      }
    })();
  }, [location, nav]);

  return (
    <main className="flex min-h-[60vh] items-center justify-center" data-testid="auth-callback">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">Signing you in…</p>
    </main>
  );
}
